import videojs from 'video.js';

/**
 * Abstract Class AudiotracksListAbstract.
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends EventTarget
 */
class AudiotracksListAbstract extends videojs.EventTarget {
	constructor(player, options) {
		super(player, options);
		if (this.constructor === AudiotracksListAbstract) {
			throw new Error("Abstract classes can't be instantiated.");
		}

		this.items = [];
	}

	isSelected(id) {
		throw new Error("Method 'isSelected()' must be implemented.");
	}

	play() {
		throw new Error("Method 'play()' must be implemented.");
	}
}

export default AudiotracksListAbstract;
